export enum ConflictErrorSeverity {
  Critical = "Critical",
  Warning = "Warning",
}
